/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-08-09 13:34:27
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-08-12 22:21:01
 * @FilePath: /intl-m-jdi-website-ssr/src/hooks/useOchamaMig.ts
 * @Description: default
 */
'use client';
import JDILogin from '@/app/login/utils';
import { EXPOSURE_RECORD } from '@/tracks/24934';
import { EXPOSURE_RECORD as LOGIN_EXPOSURE_RECORD } from '@/tracks/25023';
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';
import { useEffect } from 'react';

const useOchamaMig = (trackType: string) => {
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const ochamaMig = queryParams.get('ochamaMig');
    if (ochamaMig) {
      const decodedMig = decodeURIComponent(ochamaMig);
      const paramObj = JSON.parse(decodedMig);
      let joybuy_fingerprintId = '-100';
      try {
        window.getJsToken(function (res: any) {
          const { jsToken } = res;
          joybuy_fingerprintId = jsToken;
        }, 3000);
      } catch (error) {}

      const sendTrack = async () => {
        let userPin = '-100';
        try {
          const { isLoggedIn, userInfo } = await JDILogin.getInstance().getUserInfo();
          userPin = isLoggedIn ? userInfo?.pin : '-100';
        } catch (error) {}
        const jsonParam = {
          ...paramObj,
          joybuy_source: 'm',
          joybuy_fingerprintId,
          joybuy_userid: userPin,
        };
        if (trackType === 'home') {
          eventTrackingUtils.submitExp({
            event_id: EXPOSURE_RECORD.Home_Ochama_User_Migrate,
            json_param: jsonParam,
          });
        } else {
          eventTrackingUtils.submitExp({
            event_id: LOGIN_EXPOSURE_RECORD.NewLogin_Ochama_User_Migrate,
            json_param: jsonParam,
          });
        }
      };

      sendTrack();
    }
  }, []);
};

export default useOchamaMig;
